import styled from 'styled-components';
import {getColors, maxMediaQueries, mediaQueries} from '../utils/styling';

const getTextColor = ({theme, color}) => {
  return getColors(theme)[color] || getColors(theme)['gray900'];
};

const H1 = styled('h1')`
  margin-bottom: ${({margin}) => margin ? '112px' : '42px'};
  font-size: 42px;
  font-weight: bold;
  line-height: 48px;
  color: ${props => getTextColor(props)};
  
  ${maxMediaQueries.sm`
    margin-bottom: ${({margin}) => margin ? '64px' : '32px'};
    font-size: 32px;
  `};
`;

const H2 = styled('h2')`
  margin-bottom: ${({margin}) => margin ? '112px' : '36px'};
  font-size: 36px;
  font-weight: bold;
  line-height: 40px;
  color: ${props => getTextColor(props)};
  
  ${maxMediaQueries.sm`
    margin-bottom: ${({margin}) => margin ? '48px' : '24px'};
    font-size: 28px;
  `};
`;

const H3 = styled('h3')`
  margin-bottom: 28px;
  font-size: 28px;
  font-weight: bold;
  line-height: 32px;
  color: ${props => getTextColor(props)};
  
  ${maxMediaQueries.sm`
    margin-bottom: 22px;
    font-size: 22px;
  `};
`;

const H4 = styled('h4')`
  margin-bottom: 22px;
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
  color: ${props => getTextColor(props)};
  
  ${maxMediaQueries.sm`
    margin-bottom: 18px;
    font-size: 18px;
  `};
`;

const H5 = styled('h5')`
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 500;
  line-height: 32px;
  color: ${props => getTextColor(props)};
  
  ${maxMediaQueries.sm`
    margin-bottom: 16px;
    font-size: 16px;
  `};
`;

const H6 = styled('h6')`
  margin-bottom: 18px;
  font-size: 18px;
  font-weight: 800;
  line-height: 24px;
  letter-spacing: ${({noSpacing}) => noSpacing ? 'initial' : '4px'};
  text-transform: uppercase;
  color: ${props => getTextColor(props)};
  
  ${maxMediaQueries.sm`
    margin-bottom: 14px;
    font-size: 14px;
  `};
`;

const H6Small = styled('h6')`
  margin-bottom: 14px;
  font-size: 14px;
  font-weight: 800;
  line-height: 24px;
  letter-spacing: ${({noSpacing}) => noSpacing ? 'initial' : '4px'};
  text-transform: uppercase;
  color: ${props => getTextColor(props)};
`;

const P = styled('p')`
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  color: ${props => getTextColor(props)};
  opacity: 0.7;
`;

const PSmall = styled('p')`
  font-size: 14px;
  font-weight: normal;
  line-height: 24px;
  color: ${props => getTextColor(props)};
`;

const PSmaller = styled('p')`
  font-size: 12px;
  font-weight: normal;
  line-height: 24px;
  color: ${props => getTextColor(props)};
`;

const TextBig = styled('p')`
  font-size: 16px;
  line-height: 32px;
  color: ${props => getTextColor(props)}
    ${props => props.center && 'text-align: center;'};
  ${maxMediaQueries.sm`
    margin-bottom:20px;
  `};
`;

const TextHighlighter = styled('span')`
  font-weight: 700;
  color: ${props => getTextColor(props)};
`;

const Text = styled('p')`
  font-size: 16px;
`;

const TextSmall = styled('p')`
  font-size: 14px;
`;

const TextXSmall = styled('p')`
  font-size: 18px;
  color: ${props => getTextColor(props)};
`;
const TextMarginated = styled('div')`
  font-size: 18px !important;
  margin: 17px 0 0 0 !important;
  padding: 0 !important;
  color: ${props => getTextColor(props)};
  ${maxMediaQueries.sm`
    margin-top: 1px;
    font-size: 16px;
  `};
`;

const TextBenefitTitle = styled.h3`
  font-family: Montserrat;
  font-size: 36px;
  font-weight: 400;
  line-height: 48px;
  color: ${props => getTextColor(props)}
 
  ${maxMediaQueries.sm`
    font-family: Modern Era;
    font-size: 24px;
    line-height: 32px;
    color: #1B5E59;
  `};
`;

const TextBenefitContent = styled.h3`
  font-family: Montserrat;
  font-size: 16px;
  font-weight: normal;
  line-height: 32px;
  ${maxMediaQueries.sm`
    font-family: Modern Era;
    line-height: 24px;
    color: #606060;
  `};
`;

const Tagline = styled.h1`
  ${mediaQueries.lg`
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 42px;
    line-height: 50px;
    text-align: center;
  `};
  
  ${maxMediaQueries.sm`
    font-family: Modern Era;
    font-size: 32px;
    line-height: 40px;
    text-align: center;
    color: #000000;
  `};
`;

const TextSubTagline = styled.h6`
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 32px;
  text-align: center;
  color: #606060;
  ${maxMediaQueries.sm`
    font-family: Modern Era;
    font-size: 18px;
    line-height: 32px;
    text-align: center;
    color: #4D4D4D;
  `};
`;

export {
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  H6Small,
  P,
  PSmall,
  PSmaller,
  TextBig,
  TextHighlighter,
  Text,
  TextSmall,
  TextXSmall,
  TextMarginated,
  TextBenefitTitle,
  TextBenefitContent,
  Tagline,
  TextSubTagline
};
